import { splitAsins } from "../../util/stringUtils";

/**
 * Split multi-value ASIN tokens (comma / whitespace / tab / newline
 * per `genericStringSplitter`) into an OR `tokenGroup` of single-ASIN
 * tokens so chips display split without a URL round-trip. Each ASIN
 * is normalized (`normalizeAsin`) so stray quotes / punctuation from a
 * paste never reach a chip or the query. Values that still aren't a
 * valid ASIN are kept as chips so the user can see them; they are shown
 * red and left out of the query (see `invalidAsinTokens.ts`). A token
 * left with no characters at all gets an empty value and is dropped by
 * `preProcessPolarisPropertyFilter`.
 */
export function splitCommaSeparatedAsinTokens(query: any): any {
  const splitToken = (token: any): any => {
    if (token?.propertyKey !== "asin") return token;
    if (typeof token.value !== "string") return token;
    const parts = splitAsins(token.value);
    if (parts.length <= 1) return { ...token, value: parts[0] ?? "" };
    return {
      operation: "or",
      tokens: parts.map((v) => ({
        propertyKey: "asin",
        value: v,
        operator: token.operator,
      })),
    };
  };

  const walkGroup = (group: any): any => {
    if (!group || typeof group !== "object") return group;
    return {
      ...group,
      tokens: (group.tokens ?? []).map((t: any) =>
        t?.operation ? walkGroup(t) : splitToken(t)
      ),
      tokenGroups: (group.tokenGroups ?? []).map((tg: any) =>
        tg?.operation ? walkGroup(tg) : splitToken(tg)
      ),
    };
  };

  return walkGroup(query);
}
